import { useState, useCallback } from 'react'


const useZoom = () => {
    const [zoom, setZoom] = useState(1);

    const handleZoomIn = useCallback(() => {
        setZoom((prevZoom) => Math.min(prevZoom + 0.1, 5)); // Max zoom level of 5
    }, []);

    const handleZoomOut = useCallback(() => {
        setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.5)); // Min zoom level of 0.5
    }, []);

    const resetZoom = useCallback(() => {
        setZoom(1)
    }, [])

    return {
        zoom,
        handleZoomIn,
        handleZoomOut,
        resetZoom
    }
}

export default useZoom